/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { educationSubFieldIdGet } from '../fn/education-sub-field/education-sub-field-id-get';
import { EducationSubFieldIdGet$Params } from '../fn/education-sub-field/education-sub-field-id-get';
import { EducationSubFieldModel } from '../models/education-sub-field-model';
import { EducationSubFieldModelSearchResultModel } from '../models/education-sub-field-model-search-result-model';
import { educationSubFieldPost } from '../fn/education-sub-field/education-sub-field-post';
import { EducationSubFieldPost$Params } from '../fn/education-sub-field/education-sub-field-post';
import { educationSubFieldSearchEducationSubFieldPost } from '../fn/education-sub-field/education-sub-field-search-education-sub-field-post';
import { EducationSubFieldSearchEducationSubFieldPost$Params } from '../fn/education-sub-field/education-sub-field-search-education-sub-field-post';

@Injectable({ providedIn: 'root' })
export class MDIEducationSubFieldService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `educationSubFieldSearchEducationSubFieldPost()` */
  static readonly EducationSubFieldSearchEducationSubFieldPostPath = '/EducationSubField/SearchEducationSubField';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `educationSubFieldSearchEducationSubFieldPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  educationSubFieldSearchEducationSubFieldPost$Response(params?: EducationSubFieldSearchEducationSubFieldPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EducationSubFieldModelSearchResultModel>> {
    return educationSubFieldSearchEducationSubFieldPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `educationSubFieldSearchEducationSubFieldPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  educationSubFieldSearchEducationSubFieldPost(params?: EducationSubFieldSearchEducationSubFieldPost$Params, context?: HttpContext): Observable<EducationSubFieldModelSearchResultModel> {
    return this.educationSubFieldSearchEducationSubFieldPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<EducationSubFieldModelSearchResultModel>): EducationSubFieldModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `educationSubFieldIdGet()` */
  static readonly EducationSubFieldIdGetPath = '/EducationSubField/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `educationSubFieldIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  educationSubFieldIdGet$Response(params: EducationSubFieldIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EducationSubFieldModel>> {
    return educationSubFieldIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `educationSubFieldIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  educationSubFieldIdGet(params: EducationSubFieldIdGet$Params, context?: HttpContext): Observable<EducationSubFieldModel> {
    return this.educationSubFieldIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<EducationSubFieldModel>): EducationSubFieldModel => r.body)
    );
  }

  /** Path part for operation `educationSubFieldPost()` */
  static readonly EducationSubFieldPostPath = '/EducationSubField';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `educationSubFieldPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  educationSubFieldPost$Response(params?: EducationSubFieldPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return educationSubFieldPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `educationSubFieldPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  educationSubFieldPost(params?: EducationSubFieldPost$Params, context?: HttpContext): Observable<string> {
    return this.educationSubFieldPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
